'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024 from "./dev.cheleb.scalamigen.-Form$package$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024 from "./dev.cheleb.scalamigen.-Hidden-Event$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dInvalide$002dEvent from "./dev.cheleb.scalamigen.-Invalide-Event.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024 from "./dev.cheleb.scalamigen.-Shown-Event$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dValid$002dEvent$0024 from "./dev.cheleb.scalamigen.-Valid-Event$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4(path$15, state$2) {
  this.hA = null;
  this.vb = null;
  this.hA = path$15;
  this.vb = state$2;
}
export { $c_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 as $c_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 };
$p = $c_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4() {
}
export { $h_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 as $h_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 };
$h_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4.prototype = $p;
$p.gz = (function(x) {
  if ((x !== null)) {
    var x13 = x.ac;
    var x14 = x.ad;
    if ((x14 instanceof $j_dev$002echeleb$002escalamigen$002e$002dInvalide$002dEvent.$c_Ldev_cheleb_scalamigen_InvalideEvent)) {
      if ((x13 === $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA))) {
        return true;
      }
    }
    if (($j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ShownEvent$() === x14)) {
      var this$2 = $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA);
      var $x_1 = (!(!this$2.startsWith(x13)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return true;
    }
    if (($j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024.$m_Ldev_cheleb_scalamigen_HiddenEvent$() === x14)) {
      var this$3 = $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA);
      var $x_2 = (!(!this$3.startsWith(x13)));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return true;
    }
    if ((($j_dev$002echeleb$002escalamigen$002e$002dValid$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ValidEvent$() === x14) && (x13 === $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA)))) {
      return true;
    }
  }
  return false;
});
$p.gt = (function(x, default$1) {
  if ((x !== null)) {
    var x25 = x.ac;
    var x26 = x.ad;
    if ((x26 instanceof $j_dev$002echeleb$002escalamigen$002e$002dInvalide$002dEvent.$c_Ldev_cheleb_scalamigen_InvalideEvent)) {
      if ((x25 === $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA))) {
        $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.vb, "invalid");
        return "srf-invalid";
      }
    }
    if (($j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ShownEvent$() === x26)) {
      var this$2 = $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA);
      var $x_1 = (!(!this$2.startsWith(x25)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return ("srf-" + this.vb.a4().b3().C());
    }
    if (($j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024.$m_Ldev_cheleb_scalamigen_HiddenEvent$() === x26)) {
      var this$5 = $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA);
      var $x_2 = (!(!this$5.startsWith(x25)));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return "srf-valid";
    }
    if ((($j_dev$002echeleb$002escalamigen$002e$002dValid$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ValidEvent$() === x26) && (x25 === $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(this.hA)))) {
      $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.vb, "valid");
      return "srf-valid";
    }
  }
  return default$1.j(x);
});
$p.de = (function(x) {
  return this.gz(x);
});
$p.cr = (function(x, default$1) {
  return this.gt(x, default$1);
});
var $d_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4, "dev.cheleb.scalamigen.Form$$anon$3$$anon$4", ({
  j3: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 as $d_Ldev_cheleb_scalamigen_Form$$anon$3$$anon$4 };
